export default __webpack_public_path__ + "static/media/icon58.8a3593b8.svg";